/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//   $(".zrx-sticky-atc-main-button").click(function () {
//   $("#sidebar-cart").attr("aria-hidden", false);
//   $(".zrx-sticky-atc-just-added-bar").css("display", "none");
// }); 


function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}

let playTabberVideo = function(){
  console.log("playTabberVideo pinged");
  let section_collection_tabbers = document.querySelectorAll('.collection-tabber');
  
  section_collection_tabbers.forEach(function(collection_tabber){
    let collection_tabber_slider = collection_tabber.querySelector('.flickity-wrapper');
    let collection_tabber_slides = collection_tabber_slider.querySelectorAll('.collection-product-slide');
    collection_tabber_slides.forEach(function(collection_tabber_slide){
      let vidElement = collection_tabber_slide.querySelector('video');
      let posterElement = collection_tabber_slide.querySelector('.video-poster');
      if(collection_tabber_slide.classList.contains('is-selected') ){
        if(vidElement){
          let video_src = vidElement.getAttribute('video-src');
          setTimeout(function(){
            vidElement.setAttribute('src', video_src);
            vidElement.play();
            vidElement.style.opacity = '1';
            posterElement.style.opacity= '0';
            posterElement.style.zIndex= '-1999';
            posterElement.style.pointerEvents= 'none';
          }, 2000);
          // vidElement.autoplay = true;
          console.log(video_src);
        }
      }else{
        if(vidElement){
            vidElement.pause();
            vidElement.setAttribute('src', '');
            console.log('Haulting last video');
        }
      }
    })
  })
  // console.log('tabber-changed');
}

window.addEventListener("load", function(){})
  
  let productVideoCardsTabbers = document.querySelectorAll(".product-video-cards .flickity-wrapper");

  productVideoCardsTabbers.forEach(function(productVideoCardsTabber){

    let productTabberNavigation = productVideoCardsTabber.closest(".collection-tabber-section").querySelector(".tabber-thumb-wrapper");
    console.log(productTabberNavigation)
    // vanilla JS
    var flkty = new Flickity( productVideoCardsTabber, {
      // options
      contain: false, 
      prevNextButtons: false, 
      adaptiveHeight: true, 
      pageDots: false, 
      wrapAround: true,
      lazyLoad: true, 
      on: {
        change: function() {
          console.log('Flickity changed ');
          playTabberVideo();
        },
        ready: function(){
          playTabberVideo();
        }
      }
    });

    var navFlkty = new Flickity( productTabberNavigation, {
      // options
      contain: true,
      pageDots: false,
      cellAlign: "center",
      prevNextButtons: false,
      imagesLoaded: false,
      lazyLoad: true,
      asNavFor: productVideoCardsTabber,
      on: {
        change: function() {
          console.log('Flickity changed ');
          playTabberVideo();
        }
      }
    });
  })


// window.addEventListener("scroll", playTabberVideo);


const tabberVideos = document.querySelectorAll('.collection-product-slide video');

let playPromo = function(){
  if(document.querySelector('.template-product') || document.querySelector('.spotted_on') || document.querySelector('.celebs-videos')){
    const promo_videos = document.querySelectorAll('.video-div');
    promo_videos.forEach(function(promo_video){
      let promo_video_src = ""
      let promo_video_count = promo_videos.length;
      // console.log({promo_video_count});
      let promo_video_ele = promo_video.classList;
      
      if(isInViewport(promo_video)){
      console.log(promo_video_ele)
        
        // When video is in the viewport
        console.log('video is in the viewport');
//           let video_src = promo_video.getAttribute('src');
//           console.log(promo_video.getAttribute('src');
        if(promo_video.getAttribute('src') == null){
          // enabling video by adding src
          if(promo_video.getAttribute('video-src') == null){
            promo_video_src = promo_video.getAttribute('src');
            promo_video.setAttribute('video-src', promo_video_src);
          }
          promo_video_src = promo_video.getAttribute('video-src');
          promo_video.setAttribute('src', promo_video_src);
          // console.log({promo_video_src});
        }
      }else{
        if(promo_video.getAttribute('src') == null){
          // enabling video by adding src
          if(promo_video.getAttribute('video-src') == null){
            promo_video_src = promo_video.getAttribute('src');
            promo_video.setAttribute('video-src', promo_video_src);
          }
          promo_video_src = promo_video.getAttribute('video-src');
          promo_video.setAttribute('src', promo_video_src);
          // console.log({promo_video_src});
        }
      }
    })
  }
}
window.addEventListener("load", function(){
  document.addEventListener('scroll', function () {
    playPromo();
    
    tabberVideos.forEach(function(tabberVideo){
      if(isInViewport(tabberVideo)){
        // Do Noting..
  //         tabberVideo.play = true;
      }else{
  //         tabberVideo.pause = true;
        tabberVideo.muted = true;
      }
    })
  })
})

// const observer = new MutationObserver(function (mutationsList) {
//   mutationsList.forEach(function (mutation) {
//     if (mutation.type === 'childList') {
//       // Reapply formatting logic here
//       const productPriceElement = document.querySelector('.zrx-sticky-atc-product-price');
//       if (productPriceElement) {
//         productPriceElement.textContent = formatPrice(productPriceElement.textContent.trim());
//       }
//       const comparePriceElement = document.querySelector('.zrx-sticky-atc-compare-price');
//       if (comparePriceElement) {
//         comparePriceElement.textContent = formatPrice(comparePriceElement.textContent.trim());
//       }
//     }
//   });
// });

// // Start observing changes in the body
// observer.observe(document.body, { childList: true, subtree: true });



// document.addEventListener('DOMContentLoaded', function () {
//   // Select the element with the class 'zrx-sticky-atc-product-title'
//   const productTitleElement = document.querySelector('.zrx-sticky-atc-product-title');

//   if (productTitleElement) {
//     // Get the product title text
//     let productTitle = productTitleElement.textContent.trim();

//     // Use a similar logic to `{{- p_title | last -}}` to display the last part of the title
//     // Split the title by a delimiter (e.g., '-') and take the last part
//     const formattedTitle = productTitle.split('-').pop().trim();

//     // Update the element with the formatted title
//     productTitleElement.textContent = formattedTitle;
//   }
// });

// BUT IT WITH FLICKITY SLIDER START


// Function to format money
function formatMoney(cents) {
  var price = cents / 100;
  return "$" + price.toFixed(2);
}


var sliderElement = document.querySelector('.product-upsell__slider');
if (sliderElement) {
  var flkty = new Flickity('.product-upsell__slider', {
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    pageDots: false,
    // other options
  });
  
  // Add event listeners for custom navigation buttons
  var prevButton = document.querySelector('.prev-next__button .prev__button');
  var nextButton = document.querySelector('.prev-next__button .next__button');

  function updateNavigationButtons() {
    if (flkty.selectedIndex === 0) {
      prevButton.classList.add("disabled");
    } else {
      prevButton.classList.remove("disabled");
    }

    if (flkty.selectedIndex === flkty.slides.length - 1) {
      nextButton.classList.add("disabled");
    } else {
      nextButton.classList.remove("disabled");
    }
  }

  if (prevButton) {
    prevButton.addEventListener('click', function() {
      flkty.previous();
      updateNavigationButtons();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function() {
      flkty.next();
      updateNavigationButtons();
    });
  }

  if($('.product-upsell__slider .upsellItem__add-to-button').length) {
    $(".product-upsell__slider .upsellItem__add-to-button").click(function() {
      var selectedBuyItWithVariantID = $(this).data('variant-id');
      $(this).addClass("loading");
      $(".loading-overlay__spinner").removeClass("hidden");
      addToCartJS(selectedBuyItWithVariantID, $(this));
    });
  }
}
// BUT IT WITH FLICKITY SLIDER END


// Select all radio buttons within the quick view product form
const radioButtons = document.querySelectorAll(".quickview_product_form input[type='radio']");



// Add a change event listener to each radio button
radioButtons.forEach((radioButton) => {
  radioButton.addEventListener("change", (event) => {
    // Find the closest ProductForm container
   
    const parentForm = event.target.closest(".ProductForm");
    const popupContent = event.target.closest(".popup-content");
    if (!parentForm) return; // Exit if no parent form is found
    console.log("parentForm == ", parentForm);

    // Get the currently selected value from the radio button
    const currentSelectedValue = event.target.value;
    $(".ProductForm__SelectedValue").text(currentSelectedValue);
    // Get all options within the product selector dropdown
    const productSelector = parentForm.querySelectorAll('[name="id"] option');
    const variantParentSelector = parentForm.querySelectorAll('.HorizontalList__Item');
      
       variantParentSelector.forEach((selectedData) => {
    // Find all input elements inside selectedData
    var variantSelect = selectedData.querySelector('input:checked'); 
  
    // If an input is checked inside this div, add the class
    if (variantSelect) {
      variantSelect.classList.add('variant-checked'); 
    } else {
      selectedData.querySelector('input').classList.remove('variant-checked'); // Remove from unselected ones
    }
  });



    // Iterate through the options to update attributes
    productSelector.forEach((option) => {
      const optionValue = option.getAttribute("data-value");

      if (optionValue === currentSelectedValue) {
        // Set "selected" attribute and add "active" class for the matching option
        option.setAttribute("selected", "selected");
        option.classList.add("active");
        
        
        // Get `data-variant-price` and `data-variant-compareprice`
        const variantPrice = option.getAttribute("data-variant-price");
        const variantComparePrice = option.getAttribute("data-variant-compareprice");

        // Update the price in `.ProductItem__Price`
        const priceElement = popupContent.querySelector(".ProductItem__Price.Regular__Price");
        if (priceElement) {
          priceElement.textContent = variantPrice;
        }

        // Update the compare price in `.Price--compareAt`
        const comparePriceElement = popupContent.querySelector(".ProductItem__Price.Price--compareAt");
        if (comparePriceElement) {
          comparePriceElement.textContent = variantComparePrice || ""; // Handle cases where compare price is null
        }
      } else {
        // Clear "selected" attribute and remove "active" class for non-matching options
        option.removeAttribute("selected");
        option.classList.remove("active");
      }
    });
  });
});

$(document).ready(function () {
  // Quick Add Button Click
  $(document).on('click', '.quick-add-wrapper button', function () {
    var $button = $(this);
    var productId = $button.closest('.quick-add-wrapper').data('product-id');
    var hasMultipleVariants = $button.attr('data-has-multiple-variants') === 'true';
    var $relatedPopupOverlay = $('.popup-overlay[data-product-id="' + productId + '"]');

    $('.popup-overlay').hide();

    if (hasMultipleVariants) {
      $relatedPopupOverlay.css('display', 'flex');
    }
  });

  // Popup Close Button Click
  $(document).on('click', '.popup-close', function () {
    $(this).closest('.popup-overlay').hide();
  });

  // Close the popup when clicking outside the popup content
  $(document).on('click', '.popup-overlay', function (e) {
    if (e.target === this) {
      $(this).hide();
    }
  });

  // Quick View ATC Event
  $(document).on('click', '.product__ATC', function() {
    var selectedVariantID = $(this).parents(".ProductForm__Variants").find("select option[selected='selected']").val();
    $(this).addClass("loading");
    $(".loading-overlay__spinner").removeClass("hidden");
    addToCartJS(selectedVariantID, $(this));
  });

  // Cart Drawer Close Event
    // Cart Drawer Close Event
$(document).on('click', ".Drawer__Close, .PageOverlay.is-visible", function() {
    $("#sidebar-cart").attr("aria-hidden", true);
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
    $("body").removeClass("cart-drawer--open");
  });

});


function addToCartJS(selectedVariantID, btn) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      if (window.location.href.indexOf("cart") > -1) {
        location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        $(".popup-overlay").hide();
        $("#sidebar-cart").attr("aria-hidden", false);
        $(".PageOverlay").addClass("is-visible");
        $("html").addClass("no-scroll");
        $("body").addClass("cart-drawer--open");
        $(".loading-overlay__spinner").addClass("hidden");
        btn.removeClass("loading");
      }
      console.log("Free Product Successfully Added");
    }
  };
  var data = JSON.stringify({"quantity": "1", "id": selectedVariantID});
  xhr.send(data);
}

document.addEventListener("DOMContentLoaded", function() {
    // Select all popups inside recommendations section
    document.querySelectorAll(".popup-overlay").forEach(function(popup) {
        document.body.appendChild(popup); // Move popup to <body>
    });
});

// new varint function start for VAVIA product
function updateVariantImages() {
  var dataOption1 = $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="1"]:checked').data('var');
  var dataOption2 = $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="2"]:checked').data('var');
  var selector = `opt-${dataOption1}-${dataOption2}`;
  console.log(selector);
  var FrameImage1 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .frame-option .frame-1`).data('src');
  var FrameImage2 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .frame-option .frame-2`).data('src');

  var artImage1 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .art-option .art-1`).data('src');
  var artImage2 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .art-option .art-2`).data('src');
  var artImage3 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .art-option .art-3`).data('src');
  var artImage4 = $(`.new-productform__varint .model-frame[data-atr="${selector}"] .art-option .art-4`).data('src');

  // Apply background images to matching labels
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="2"][data-var="1"] + label').css('background-image', 'url(' + FrameImage1 + ')');
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="2"][data-var="2"] + label').css('background-image', 'url(' + FrameImage2 + ')');
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="3"][data-var="1"] + label').css('background-image', 'url(' + artImage1 + ')');
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="3"][data-var="2"] + label').css('background-image', 'url(' + artImage2 + ')');
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="3"][data-var="3"] + label').css('background-image', 'url(' + artImage3 + ')');
  $('.template_new-varint .HorizontalList__Item input[name^="option"][data-opt="3"][data-var="4"] + label').css('background-image', 'url(' + artImage4 + ')');
}

$(document).ready(function () {
  // Run once on page load
  updateVariantImages();

  // Re-run when variant selection changes
  $(document).on('change', '.template_new-varint .HorizontalList__Item input[name^="option"]', function () {
    updateVariantImages();
  });
});
